module.exports = __webpack_public_path__ + "static/usa-today-grey.a80741e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/press/usa-today-grey.svg
// module id = 1709
// module chunks = 35783957827783